module.exports = __webpack_public_path__ + "img/erskine_b2.53f1ee98.jpg";